import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CardModule } from '@modules/card/card.module';
import { ConsentModule } from '@modules/consent/consent.module';
import { MediaModule } from '@modules/media/media.module';
import { PipesModule } from '@modules/pipes/pipes.module';
import { AppTranslationModule } from '@modules/translation/app-translation.module';
import { UiModule } from '@modules/ui/ui.module';

import { StreamPlayerErrorComponent } from './stream-player-error/stream-player-error.component';
import { StreamPlayerWrapperComponent } from './stream-player-wrapper/stream-player-wrapper.component';
import { StreamPlayerComponent } from './stream-player.component';
import { ThumbControlComponent } from './thumb-control/thumb-control.component';
import { TranscriptContentComponent } from './transcript/transcript-content/transcript-content.component';
import { TranscriptSectionSelectionComponent } from './transcript/transcript-section-selection/transcript-section-selection.component';
import { TranscriptTagSelectionComponent } from './transcript/transcript-tag-selection/transcript-tag-selection.component';
import { TranscriptComponent } from './transcript/transcript.component';

@NgModule({
  declarations: [
    StreamPlayerComponent,
    ThumbControlComponent,
    TranscriptComponent,
    TranscriptTagSelectionComponent,
    TranscriptSectionSelectionComponent,
    TranscriptContentComponent,
    StreamPlayerErrorComponent,
    StreamPlayerWrapperComponent,
  ],
  imports: [
    CommonModule,
    DragDropModule,
    PipesModule,
    ConsentModule,
    UiModule,
    MediaModule,
    CardModule,
    AppTranslationModule.forChild(),
  ],
  exports: [StreamPlayerComponent, StreamPlayerErrorComponent, StreamPlayerWrapperComponent],
})
export class StreamPlayerModule {}
